
































































































import { Component, Vue } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import ShareModel from '../comps/share-model.vue'
import { sleep } from '@ivy/fts/utils'
import { requireGet, requirePost, addStatistics } from '../api'

@Component({
  components: {
    ShareModel,
  },
})
export default class extends Vue {
  activityId: any
  ios10Shadow: boolean = false
  recordList: any[] = []
  showShare: boolean = false
  share_img_url: any
  first_id: any
  appName: string = ''
  id: any = ''
  //当前查看类型 1是我发起的 2是我参与的
  type = 1
  isloading: boolean = true
  default_share_img: any =
    'http://service.ivydad.com/unamed/46873ebc-aca4-9b0a-dd69-71fea2b7a3fe.jpg'
  memId: any
  //我发起的列表
  publishList = []
  //我加入的列表
  joinList = []
  async mounted() {
    document.title = '组队免费学'
    let type = +this.$route.query.tab || 1
    console.log('rrrr', type)
    this.type = type
    await env.init()
    if (env.type === 'web') return this.$Toast('请在App或微信中打开')
    let info = await env.getInfo()
    if (env.type === 'ivydad') {
      this.appName = info.publicParams.app_name
    }
    if (!(await env.getIsLogin())) {
      this.ios10Shadow = true
      return await env.login()
    }
    this.memId = env.type === 'wx' ? info.logined.user.id : info.userInfo.memId
    this.activityId = this.$route.query.activityId
    await this.initTeamRecord()
    env.type === 'wx' && (await this.setShare())
  }
  onClickTab(type) {
    this.type = type
    if (type == 1) {
      this.recordList = this.publishList
    } else {
      this.recordList = this.joinList
    }
    this.cutDownTime()
  }
  async initTeamRecord() {
    this.publishList.length = 0
    this.joinList.length = 0
    await this.getAttendRecord()
  }
  // ios10 env.login()页面不刷新问题
  async ios10ShadowClick() {
    window.location.reload()
  }

  // 获取活动参与记录
  async getAttendRecord() {
    this.isloading = true
    const { data: attendInfo } = await requirePost(
      '/api/activity/appActivity/deadlineteam/getTeamRecord',
      {
        activity_id: +this.activityId,
      }
    )
    //zmtest
    let aa = attendInfo
    this.setTeamDeatailData(aa.publish_record, this.publishList)
    this.setTeamDeatailData(aa.join_record, this.joinList)
    this.isloading = false
    this.onClickTab(this.type)
  }
  //设置
  setTeamDeatailData(data, receiveList) {
    if (receiveList.length > 0) return
    let attend_Info = []
    if (data) {
      for (let key in data) {
        attend_Info.push(data[key])
      }
    }
    for (let ke in attend_Info) {
      let attendObj = {}
      let userList = []
      let myInfo = attend_Info[ke].find(my => +my.mem_id === +this.memId)
      let headInfo =
        (myInfo &&
          myInfo.config &&
          myInfo.config.head_list &&
          myInfo.config.head_list
            .filter(head => {
              return head.ispublish === 'yes' && head.isshow === 'yes'
            })
            .find(vi => {
              return (
                +new Date(vi.begin_time.replace(/-/g, '/')) <=
                  +new Date(myInfo.create_time.replace(/-/g, '/')) &&
                +new Date(vi.end_time.replace(/-/g, '/')) >=
                  +new Date(myInfo.create_time.replace(/-/g, '/'))
              )
            })) ||
        {}
      let len = attend_Info[ke].length
      for (let k in attend_Info[ke]) {
        if (attend_Info[ke][k].status !== 'no_login') {
          userList.push({
            avatar_url: attend_Info[ke][k].avatar_url,
            user_nick: attend_Info[ke][k].user_nick,
          })
        }
        attendObj['new_head_url'] = (headInfo && headInfo.head_img_url) || ''
        attendObj = Object.assign(
          attendObj,
          { ...attend_Info[ke][len - +k - 1] },
          { inviteList: userList }
        )
      }
      receiveList.push(attendObj)
    }
    // 排序最新的在上面
    receiveList.sort((a, b) => {
      return b.id - a.id
    })
  }
  // 跳转组队详情页面
  goToTeamDetail(id) {
    this.$router.push({
      path: `/teamFree/teamDetail`,
      query: {
        activityId: this.activityId,
        id,
        _hideShareButton: '1',
      },
    })
  }

  // 分别计算每条组队的倒计时
  async cutDownTime() {
    this.first_id = this.recordList.length && this.recordList[0].id
    for (let i = 0; i < this.recordList.length; i++) {
      if (this.recordList[i].status !== 'wait') continue
      let success_time = this.recordList[i].success_time
      let endTime = this.recordList[i].end_time.replace(/-/g, '/')
      let end_time: number = 0
      let createTime = new Date(
        this.recordList[i].create_time.replace(/-/g, '/')
      ).getTime()
      if (
        success_time * 3600 <
        (new Date(endTime).getTime() - createTime) / 1000
      ) {
        end_time = success_time * 3600 * 1000 + createTime
      } else {
        end_time = new Date(endTime.replace(/-/g, '/')).getTime()
      }
      this.getLeftTime(end_time, i, this.first_id)
    }
  }

  async getLeftTime(end_time, i, first_id) {
    if (this.first_id !== first_id) return
    let timediff = (end_time - new Date().getTime()) / 1000
    if (
      +timediff <= 0 &&
      !!this.recordList[i].last_timediffer &&
      +this.recordList[i].last_timediffer > 0
    ) {
      Vue.set(this.recordList[i], 'last_timediffer', 0)
      window.location.reload()
      return
    } else if (+timediff > 0) {
      Vue.set(this.recordList[i], 'last_timediffer', 1)
    }
    let day: number = Math.floor(timediff / 86400)
    let hour: number = Math.floor((timediff / 3600) % 24)
    let minutes: number = Math.floor((timediff / 60) % 60)
    let second: number = Math.floor(timediff % 60)
    if (timediff) {
      let cutDownTime = `${this.addZero(day)}天${this.addZero(
        hour
      )}:${this.addZero(minutes)}:${this.addZero(second)}`
      Vue.set(this.recordList[i], 'cutDownTime', cutDownTime)
      await sleep(1000)
      this.getLeftTime(end_time, i, first_id)
    } else {
      return '00天00:00:00'
    }
  }
  addZero(value) {
    return value < 10 ? `0${value}` : value
  }

  getAvatar(team, i) {
    return team.inviteList && team.inviteList[i - 1]
      ? team.inviteList[i - 1].avatar_url
      : require('../imgs/empty-avatar.png')
  }

  getButtonText(team) {
    if (team.status === 'wait' || team.status === 'success') {
      return '去查看'
    } else if (
      team.status === 'fail' &&
      +new Date() < +new Date(team.end_time.replace(/-/g, '/'))
    ) {
      if (this.type == 1) {
        return '重新发起'
      } else {
        return '去查看'
      }
    } else {
      return '已结束'
    }
  }

  async handlerAction(team) {
    // if (team.status === 'wait') {
    //   let appName = env.type === 'ivydad' ? this.appName : 'h5'
    //   const { data: shareInfo } = await requireGet(
    //     `/api/activity/appActivity/teamActivity/getUserPoster?activityId=${
    //       this.activityId
    //     }&team_id=${team.team_id}&team_activity_id=${
    //       team.team_activity_id
    //     }&appName=${appName}`
    //   )
    //   if (!shareInfo.status_code) {
    //     this.id = team.team_activity_id
    //     this.share_img_url = shareInfo
    //     this.showShare = true
    //   } else {
    //     this.$Toast(shareInfo.message)
    //   }
    //   this.showShare = true
    // } else
    if (
      team.status === 'wait' ||
      team.status === 'success' ||
      (this.type === 2 &&
        team.status === 'fail' &&
        +new Date() < +new Date(team.end_time.replace(/-/g, '/')))
    ) {
      this.$router.push({
        path: `/teamFree/teamDetail`,
        query: {
          activityId: this.activityId,
          id: team.team_activity_id,
          team_id: team.team_id,
          _hideShareButton: '1',
        },
      })
    } else if (
      this.type === 1 &&
      team.status === 'fail' &&
      +new Date() < +new Date(team.end_time.replace(/-/g, '/'))
    ) {
      // 重新发起 调用发起组队API 生成一条新的组队
      try {
        // 埋点-重新发起组队按钮的点击
        await addStatistics({
          activity_id: this.activityId,
          event_type: 'Click_NewTeam_xszd',
          p1: team.team_activity_id,
          p2: env.type === 'ivydad' ? this.appName : 'h5',
        })
      } catch {}
      const { data: res } = await requirePost(
        '/api/activity/appActivity/teamActivity/publishTeam',
        {
          team_activity_id: team.team_activity_id,
          app_name: env.type === 'ivydad' ? this.appName : 'h5',
        },
        {
          disableLoading: false,
          disableAlert: false,
          disableNetWorkError: true,
        }
      )
      if (res.team_id) {
        this.initTeamRecord()
      } else {
        this.$Toast(res.message)
      }
    }
  }
  async setShare() {
    let pic_url =
      (this.recordList &&
        this.recordList.length &&
        (this.recordList[0].head_url || this.recordList[0].new_head_url)) ||
      this.default_share_img
    let shareData = {
      title: `我在【常青藤爸爸】发现了高效好课`,
      content: `快来跟我一起组队免费学！`,
      pic_url,
      url: window.location.href,
    }
    await env.share(shareData)
  }
}
